import React, {FC} from "react";
import logo from '../../../assets/images/logo.png'
import location from '../../../assets/images/location.png'
import plane from '../../../assets/images/plane.png'
import './shops-page.less'
import {ShopTypes} from "../../../bll/types";
import {Rate} from 'antd';

type PropsType = {
    shop: ShopTypes
}

export const ShopGard: FC<PropsType> = ({shop}) => {
    return <div className="container">
            <div className="shop-item">
                <div className="icon">
                    <img src={shop.image}/>
                </div>
                <div className="description">
                    <div className="name-shop">
                        <span>{shop.title}</span>
                        <div className="reviews">
                            <div className='reviews-count'>ПОКУПОК: {shop.salesCount}</div>
                            <Rate disabled allowHalf defaultValue={shop.ratingSum / shop.salesCount} />
                        </div>
                    </div>
                    <div className="shot-description">
                        <a href="" className="address">
                            <img src={location}/>{shop.country}/{shop.city}
                        </a>
                        {shop.allWorldDelivery && <a href="" className="delivery">
                            <img src={plane}/> <span>Доставка по всему миру</span>
                        </a> }
                    </div>
                </div>
            </div>
        </div>
}